import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuthentication } from 'hooks';
import { Loader } from 'components';
import { getEnvironmentVariable } from 'configuration';

export function ProtectedPages() {
    const { user, loading } = useAuthentication();
    const location = useLocation();

    if (loading) {
        return <Loader loadingMessage="Loading..." />;
    }

    if (!user) {
        const returnUrl = location.pathname + location.search;
        const currentHost = window.location.hostname;
        const authUrl = getEnvironmentVariable('REACT_APP_AUTH_URL');

        if (authUrl && !currentHost.includes('oneauth')) {
            window.location.href = `${authUrl}/sign-in?returnUrl=${encodeURIComponent(window.location.href)}`;
            return <Loader loadingMessage="Redirecting to sign in..." />;
        }

        return <Navigate to="/sign-in" state={{ returnUrl }} replace />;
    }

    // Handle root redirect for authenticated users
    if (location.pathname === '/') {
        return <Navigate to="/profile" replace />;
    }

    return <Outlet />;
}